import React, { useState } from "react";
import "./ServiceComparison.css";
import ViewallButton from "../../../utility/components/ViewallButton";
import CommonButton from "../../../utility/components/CommonButton";
import { useNavigate } from "react-router-dom";

const TitleComponent = ({ title }) => (
    <div className="comparison__title-container">
        <h1>{title}</h1>
    </div>
);

const ComparisonItem = ({ src, alt, title }) => {
    const imageSrc = require(`../../../assets/img/${src}`);
    return (
        <div className="comparison__card-container">
            <div className="image-container">
                <img src={imageSrc} alt={alt} />
            </div>
            <div className="title-container">
                <p>{title}</p>
            </div>
        </div>
    );
};

const ComparisonForm = ({ showAll }) => {
    const items = [
        { src: "interior1.jpg", alt: "service image", title: "Personal Guidebook" },
        { src: "interior2.jpg", alt: "service image", title: "Full-Service Interior Decoration" },
        { src: "exterior1.jpg", alt: "service image", title: "Personal Exterior Guidebook" },
        { src: "exterior2.jpg", alt: "service image", title: "Full-Service Exterior Decoration" },
    ];

    const data = [
        { Price: "$100", Content: "Consultant", InPersonService: "——", Support: "24/7", Document: "Yes", Duration: "2 days" },
        { Price: "$200", Content: "Strategy", InPersonService: "Yes", Support: "Business Hours", Document: "Yes", Duration: "2 days" },
        { Price: "$150", Content: "Marketing", InPersonService: "——", Support: "24/7", Document: "Yes", Duration: "2 days" },
        { Price: "$120", Content: "Finance", InPersonService: "Yes", Support: "Limited", Document: "Yes", Duration: "2 days" },
    ];

    const headers = [
        { displayName: "Price", key: "Price" },
        { displayName: "Content", key: "Content" },
        { displayName: "In-person Service", key: "InPersonService" },
        { displayName: "Support", key: "Support" },
        { displayName: "Duration", key: "Duration" },
        { displayName: "Document", key: "Document" }
    ];

    const displayRows = showAll ? headers : headers.slice(0, 5);

    return (
        <div className="comparison__table-container">
            <table className="comparison__table">
                <tbody>
                    <tr>
                        <th></th>
                        {items.map((item, index) => (
                            <td key={index}>
                                <ComparisonItem {...item} />
                            </td>
                        ))}
                    </tr>
                    {displayRows.map((header, index) => (
                        <tr key={index}>
                            <th>{header.displayName}</th>
                            {data.map((item, idx) => (
                                <td key={idx}>{item[header.key]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const ButtonComponent = ({ showAll, setShowAll }) => {
    const navigate = useNavigate();

    return (
        <div className="button__container">
            <div className="view-all__button-container">
                <ViewallButton onClick={() => setShowAll(!showAll)} isExpanded={showAll} />
            </div>
            <div className="commonbutton__container">
                <CommonButton size="small" backgroundStyle="light" onClick={() => navigate("/booking")}>
                    BOOK A SESSION
                </CommonButton>
            </div>
        </div>
    );
};

export const ServiceComparison = () => {
    const [showAll, setShowAll] = useState(false);

    return (
        <section className="service__comparison-container">
            <TitleComponent title="Service Comparison" />
            <ComparisonForm showAll={showAll} />
            <ButtonComponent showAll={showAll} setShowAll={setShowAll} />
        </section>
    );
};
